exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.titleH3{\n  text-align: center;\n  width: 475px;\n}\n", ""]);

// exports
